import React from 'react';
import styled from 'styled-components';
import { NavLink, withRouter, useHistory } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { logout } from '../../actions/login';

const Navbar = ({ location }) => {
  if (location.pathname === '/login') return null;
  const history = useHistory();
  const handleLogout = () => {
    logout();
    if (location.pathname === '/') {
      history.push('/dishes');
    } else {
      history.push('/');
    }
  };
  if (location.pathname.includes('/youslim2.0')) return <React.Fragment />;
  return (
    <Nav>
      <StyledLink exact to="/">
        Пользователи
      </StyledLink>
      <StyledLink to="/templates">Питание</StyledLink>
      <StyledLink to="/templateVideos">Тренировки</StyledLink>
      <StyledLink to="/tags">Теги</StyledLink>
      <LogoutButtons inverted color="grey" onClick={handleLogout}>
        Logout
      </LogoutButtons>
    </Nav>
  );
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default withRouter(connect(null, mapDispatchToProps)(Navbar));

const Nav = styled.nav`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background: #17ade3;
`;

const LogoutButtons = styled(Button)`
  position: absolute;
  right: 30px;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  display: block;
  height: 100%;
  padding: 0 10px;
  color: #ffffff;
  line-height: 50px;
  text-decoration: none;
  transition: all 0.3s;
  background: #17ade3;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/Navbar.jsx